import { useTranslation } from 'react-i18next';
import Button, { BUTTON_VARIANTS, ButtonProps } from '@/atoms/Button';

const ButtonWrap = ({ primary, secondary }: { primary?: ButtonProps; secondary?: ButtonProps }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col-reverse md:flex-row gap-3 px-4 pb-4 w-full">
      {secondary && (
        <Button className="w-full" {...secondary} variant={BUTTON_VARIANTS.SECONDARY}>
          {typeof secondary.children === 'string' && t(secondary.children)}
        </Button>
      )}
      {primary && (
        <Button {...primary} className="w-full">
          {typeof primary.children === 'string' && t(primary.children)}
        </Button>
      )}
    </div>
  );
};

export default ButtonWrap;
